<template>
	<!-- 帳戶設定》发票资讯 -->
	<div class="deal_index_box">
		<!-- 内容 -->
		<div class="deal_title">
			<div>帳戶設定<span>》</span>發票資訊</div>
			<div class="deal_hr">
				<div class="cut_off"></div>
			</div>
		</div>
		<!-- 收取方式 -->
		<div class="deal_content_box">
			<div class="deal_content_title">收取方式</div>
			<el-form :model="formMail" label-width="120px" class="demo-formMail input_high deal_content">
				<el-form-item >
					<el-col :span="12" :xs="12" class="list_tile_sed " >
						<i class="el-icon-warning colro-red"></i><span >您送出的資料尚在審核中，審核期間無法再次變更，請耐心等待</span>
					</el-col>
				</el-form-item>
				<el-form-item >
					<el-col  >
					<el-radio v-model="formMail.radio" label="1" class="list-magr"><span>發票捐贈慈善機構（統一贈至<span>社團法人台灣之心愛護動物協會</span>）</span></el-radio>
	        </el-col>
					<el-radio v-model="formMail.radio" label="2" class="list-magr" >發票手機載具</el-radio>
				</el-form-item>
				<el-form-item label="手機載具條碼：">
					<el-col :span="4" >
						<el-input v-model="formMail.region3"></el-input>
					</el-col>
					<el-col :span="5">
						<span class="color_list_e">載具格式有誤</span>
					</el-col>
				</el-form-item>
				<el-form-item label="重複載具條碼：">
					<el-col :span="4" >
						<el-input v-model="formMail.code"></el-input>
					</el-col>
					<el-col :span="5">
						<span class="color_list_e">與前一次輸入條碼不符</span>
					</el-col>
				</el-form-item>
				<el-form-item class="list-magr" >
					<el-radio v-model="formMail.radio" label="3">索取紙本發票（請正確輸入收件資料，以免發票寄失）</el-radio>
				</el-form-item>
				<el-form-item label="收件姓名：">
					<el-col :span="6">
						<el-input v-model="formMail.region" ></el-input>
					</el-col>
				</el-form-item>
				<el-form-item label="收件地址：">
					<el-col :span="5">
						<el-select v-model="formMail.date1" placeholder="台北市100中正區">
							<el-option label="台北市100中正區" value="shanghai"></el-option>
							<el-option label="台北市中正區" value="beijing"></el-option>
						</el-select>
					</el-col>
					<el-col :span="6">
						<el-input v-model="formMail.region2" ></el-input>
					</el-col>
				</el-form-item>

				<el-form-item class="button_stend list-magr">
					<el-button @click="resetForm('formMail')" class="bottom_two">儲存</el-button>
					<span class="color_list_e">儲存成功！</span>
					
				</el-form-item>
			</el-form>
			<!-- 發票明細 -->
			<div class="deal_content_box">
			    <div class="deal_content_title">發票明細</div>
			    <div class="deal_content">
			        <div class="deal_content_tab"  >
			            <div class="deal_content_tab_first" >
			                <!-- 訂單列表查詢 -->
			                <div class="datetime_box">
			                    <!-- 交易時間：
			                    <el-select v-model="xxx" placeholder="起始日期">
			                    </el-select>
			                    <span>至</span>
			                    <el-select v-model="date" placeholder="结束日期">
			                    </el-select> -->
								<span>操作執行時間：</span>
			                    <el-date-picker
			                        v-model="dateValue"
			                        type="daterange"
			                        align="center" 
			                        unlink-panels
			                        range-separator="到"
			                        start-placeholder="開始日期"
			                        end-placeholder="結束日期 "
			                        :picker-options="pickerOptions">
			                    </el-date-picker>
			                    <span class="deal_content_span">查詢期日不可超過31天</span>
			                </div>
			     
			                <!-- 查詢按钮 -->
			                <div class="datetime_box">
			                <el-button type="primary">查詢</el-button>   
			                </div>
			                <!-- 表单 -->
			                <div class="table_download"> 
			                    <span>匯出紀錄</span>
			                    <span><img src="../../../../assets/img/login/logindeal/icon_xls.png" alt=""></span>
			                    <span><img src="../../../../assets/img/login/logindeal/icon_txt.png" alt=""></span>
			                </div>
			                <div>
			                    <!-- 表单头 -->
			                    <div class="table_header">
			                        <div class="table_date">開立日期</div>
			                        <div class="table_merchantorder">發票金額</div>
			                        <div class="table_paymentorder">發票狀態</div>
			                        <div class="table_paymenttype">收取方式</div>
			                        <div class="table_status">發票號碼</div>
			                        <div class="table_operation">狀態</div>
			                    </div>
			                    <!-- 表单内容 -->
			                    <div class="table_content" v-for="item of tableData" :key="item.id">
			                        <div class="table_date">{{item.date}}</div>
			                        <div class="table_merchantorder">{{item.merchantOrder}}</div>
			                        <div class="table_paymentorder">{{item.paymentOrder}}</div>
			                        <div class="table_paymenttype">{{item.paymentType}}</div>
									<div class="table_money">{{item.status}}</div>
			                        <div class="table_money">{{item.money}}</div>
			                    </div>
			                    <!-- 表单分页列表 -->
			                    <div class="table_pagination">
			                        <el-pagination
			                            @next-click="handleSizeChange"
			                            @prev-click="handleClick"
																	@current-change="handleCurrentChange"
			                            :current-page="page"
			                            :page-sizes="[10]"
			                            :page-size="10"
			                            layout="total, sizes, prev, pager, next, jumper"
			                            :total="total"
			                            >
			                        </el-pagination>
			                    </div>
			                </div>
			
			            </div>
			          
			    </div>
			    </div>
			</div>
			<!-- deal_index_box -->
		</div>
	</div>



</template>

<script>
	export default {
		data() {
			return {
				currentPage:'',
				total:'10',
				dateValue:'',
        page:'',
				formMail: {
					region:'',
					code:'',
					option:'',
				    type: '1',
				    password: '',
				    checkPass: '',
				    uid: '',
				    companyName: '',
				    companyNumber: '',
				    principal: '',
				    radio: '1',
				    identity: '',
				    yearValue: '',
				    monthValue: '',
				    dayValue: '',
				    siteValue: '',
				    certificateRadio: '1',
				    // 上传：1~3
				    fileBusiness: {},
				    fileFront: {},
				    fileReverse: {},
				    // 身份验证是否成功？
				    sfSussess: ''
				  },
				  formMailRemind: {
				    password: '請輸入密碼',
				    checkPass: '請再次輸入密碼',
				    companyName: '公司名稱不能為空',
				    companyNumber: '標號不能為空',
				    principal: '負責人名字不能為空',
				    identity: '身份證字號不能為空',
				    identityTime: '請選擇發證時間',
				    siteValue: '請選擇發證地點',
				    authentication: '身份驗證錯誤，請完善上訴資料',
				    // 上传：1~3
				    fileBusiness: '只能上傳jpg/png文件，且不超過5M',
				    fileFront: '只能上傳jpg/png文件，且不超過5M',
				    fileReverse: '只能上傳jpg/png文件，且不超過5M'
				  },
				  monthOptions: [{
				      value: '1月',
				      label: '1'
				    }, {
				      value: '2月',
				      label: '2'
				    }, {
				      value: '3月',
				      label: '3'
				    }, {
				      value: '4月',
				      label: '4'
				    }, {
				      value: '5月',
				      label: '5'
				    }, {
				      value: '6月',
				      label: '6'
				    }, {
				      value: '7月',
				      label: '7'
				    }, {
				      value: '8月',
				      label: '8'
				    }, {
				      value: '9月',
				      label: '9'
				    }, {
				      value: '10月',
				      label: '10'
				    }, {
				      value: '11月',
				      label: '11'
				    }, {
				      value: '12月',
				      label: '12'
				  }],
				  dayOptions: [{
				      value: '1日',
				      label: '1'
				    }, {
				      value: '2日',
				      label: '2'
				    }, {
				      value: '3日',
				      label: '3'
				    },{
				      value: '4日',
				      label: '4'
				    }, {
				      value: '5日',
				      label: '5'
				    }, {
				      value: '6日',
				      label: '6'
				    },{
				      value: '7日',
				      label: '7'
				    }, {
				      value: '8日',
				      label: '8'
				    }, {
				      value: '9日',
				      label: '9'
				    },{
				      value: '10日',
				      label: '10'
				    }, {
				      value: '11日',
				      label: '11'
				    }, {
				      value: '12日',
				      label: '12'
				    },{
				      value: '13日',
				      label: '13'
				    },{
				      value: '14日',
				      label: '14'
				    },{
				      value: '15日',
				      label: '15'
				    },{
				      value: '16日',
				      label: '16'
				    }, {
				      value: '17日',
				      label: '17'
				    }, {
				      value: '18日',
				      label: '18'
				    },{
				      value: '19日',
				      label: '19'
				    },{
				      value: '20日',
				      label: '20'
				    },{
				      value: '21日',
				      label: '21'
				    },{
				      value: '22日',
				      label: '22'
				    }, {
				      value: '23日',
				      label: '23'
				    }, {
				      value: '24日',
				      label: '24'
				    },{
				      value: '25日',
				      label: '25'
				    },{
				      value: '26日',
				      label: '26'
				    }, {
				      value: '27日',
				      label: '27'
				    }, {
				      value: '28日',
				      label: '28'
				    },{
				      value: '29日',
				      label: '29'
				    }, {
				      value: '30日',
				      label: '30'
				    }, {
				      value: '31日',
				      label: '31'
				  }],
				  siteOptions: [{
				      value: '10001',
				      label: '北縣'
				    }, {
				      value: '10002',
				      label: '宜縣'
				    }, {
				      value: '10003',
				      label: '桃縣'
				    }, {
				      value: '10004',
				      label: '竹縣'
				    }, {
				      value: '10005',
				      label: '苗縣'
				    }, {
				      value: '10006',
				      label: '中縣'
				    }, {
				      value: '10007',
				      label: '彰縣'
				  }],
				  formBank: {
				    type: '1',
				    name: '',
				    affiliation: '',
				    account: '',
				    numberVal: ''
				  },
				  formBankTF: false,
				  formBankSucc: false,
				  numberOptions: [{
				      value: '代码1',
				      label: '代码1'
				    }, {
				      value: '代码2',
				      label: '代码2'
				    }, {
				      value: '代码3',
				      label: '代码3'
				  }],
				  formHotel: {
				    name: '',
				    phone: '',
				    typeVal: '',
				    hotelList: [],
				    hotelListName: ''
				  },
				  formHotelTF: {
				    name: false,
				    phone: false,
				    typeVal: false,
				    hotelList: false
				  },
				  formHotelSucc: {
				    name: false,
				    phone: false,
				    typeVal: false,
				    hotelList: false
				  },
				  typeOptions: [{
				      value: '选项1',
				      label: '类型1'
				    }, {
				      value: '选项2',
				      label: '类型2'
				    }, {
				      value: '选项3',
				      label: '类型3'
				  }],
				

				rules: {
					name: [{
							required: true,
							message: '',
							trigger: 'blur'
						},
						{
							min: 3,
							max: 5,
							message: '',
							trigger: 'blur'
						}
					],
					region: [{
						required: true,
						message: '',
						trigger: 'change'
					}],
				},
				// 表单
				tableData: [{
				    id: "001",
				    date: '2019-03-14 11:26:11',
				    merchantOrder: '陳莜晴(121456789)',
				    paymentOrder: '202.020.22.23',
				    paymentType: '台灣新北市',
				    status: '..info',
				    money: '修改登入密碼'
				}, {
				    id: "002",
				    date: '2019-03-14 11:26:11',
				    merchantOrder: '陳莜晴(121456789)',
				    paymentOrder: '202.020.22.23',
				    paymentType: '台灣新北市',
				    status: '..info',
				    money: '修改資訊'
				}, {
				    id: "003",
				    date: '2019-03-15 11:26:11',
				    merchantOrder: '陳莜晴(121456789)',
				    paymentOrder: '202.020.22.23',
				    paymentType: '台灣新北市',
				    status: '..info',
				    money: '修改交易密碼'
				}, {
				    id: "004",
				    date: '2019-03-17 11:26:11',
				    merchantOrder: '陳莜晴(121456789)',
				    paymentOrder: '202.020.22.23',
				    paymentType: '台灣新北市',
				    status: '..info',
				    money: '修改交易密碼'
				}],
				// 日期
				pickerOptions: {
				    shortcuts: [{
				        text: '最近一週',
				        onClick(picker) {
				        const end = new Date();
				        const start = new Date();
				        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
				        picker.$emit('pick', [start, end]);
				        }
				    }, {
				        text: '最近一個月',
				        onClick(picker) {
				        const end = new Date();
				        const start = new Date();
				        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
				        picker.$emit('pick', [start, end]);
				        }
				    }]
				},
			};
		},
		methods: {
			handleSizeChange(val) {
					  this.page=this.page+1;
			},
			handleClick(val) {
			   //console.log(`当前页: ${val}`);
					 this.page=this.page-1;
			},
			handleCurrentChange(val) {
					  console.log(this.page);
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						alert('submit!');
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			}
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	/* 表单 */
	.table_download {
	    display: flex;
	    justify-content: flex-end;
	    align-items: center;
	}
	.table_download span {
	    display: inline-block;
	    margin: 0 10px;
	}
	/* 表頭 */
	.deal_index_box {
		margin: 20px;
		font-size: 15px;
		color: black;
	}

	.deal_title {
		display: flex;
		justify-content: flex-start;
		padding-bottom: 10px;
	}

	.deal_title span {
		margin-left: 15px;
		margin-right: 8px;
	}

	.deal_title .deal_hr {
		flex: 1;
		margin-left: 18px;
	}
	.list-magr{
		margin-left: -100px;
	}

	.deal_title .deal_hr .cut_off {
		height: 3px;
		background: black;
		margin-top: 8px;
	}

	/* 内容 */
	.datetime_box>span {
		margin: 10px;
	}

	.deal_content_box {
		font-size: 13px;
		margin-top: 20px;
		margin-bottom: 20px;
	}

	.deal_content_title {
		height: 42px;
		background: #666666;
		line-height: 42px;
		color: white;
		padding-left: 14px;
	}

	.deal_content {
		box-sizing: border-box;
		/* height: 53.6vw; */
		/* min-height: 100px; */
		border: 1px solid #666666;
		background: #ffffff;
		padding: 0 20px;
		padding-top: 26px;
	}

	.deal_content_span {
		margin-left: 23px;
		font-size: 11px;
		color: #e73262;
	}

	.deal_content_tab_first {
		width: 960px;
		margin: 0 auto;
	}

	.deal_content_tab_first>div {
		margin: 14px 0;
	}



	.deal_content_title span {
		display: block;
		height: 35px;
		width: 30px;
		float: right;
		padding-left: 10px;
		padding-top: 5px;
		background: url("../../../../assets/img/user/service_list.png") center no-repeat;
	}



	.div_bottom div {
		margin-bottom: 25px;
		color: #777777;
	}




	/* 按鈕 */
	.input_high .el-input .el-input__inner {
		height: 27px;
		border: 1px solid #cccccc;
	}

	.input_high .el-input i {
		line-height: 30px;
	}

	.input_high {
		padding-left: 10px;
	}

	.check_right label {
		margin-right: 5px;
	}

	.list_tile_sed {
		background-color: #fff4cc;
		line-height: 40px;
		margin: 10px 100px 25px -80px;

	}

	.colro-red {
		color: #ff771a;
		font-size: 20px;
		padding-left: 10px;
		padding-right: 10px;
	}


	.list_span {
		color: #e73262;
	}

	.right_col {
		float: left;
	}

	.right_col_left {
		color: #4d80e7;
		padding-left: 15px
	}

	.list_span_end {
		color: #e73262;
		padding-left: 15px;
	}

	.div_bntoon {
		color: #e73262;
		border-bottom: 1px solid #e73262;
	}

	.button_cetent {
		padding-bottom: 5px;
		padding-left: 10px;
	}

	.button_cetent button {
		background-color: #ff771a;
		border: #ff771a;
		height: 20px;
		padding-bottom: 5px;
		padding-top: 2px;
		padding-left: 3px;
		padding-right: 3px;
		width: 90px;
		font-size: 11px;
	}

	.button_stend {
		padding-bottom: 25px;
	}
    .button_stend_stes button{
		height: 22px;
		padding-bottom: 5px;
		padding-top: 2px;
		padding-left: 8px;
		padding-right: 10px;
		width: 75px;
		font-weight: 700;
	}
	.button_stend button {

		height: 22px;
		padding-bottom: 5px;
		padding-top: 2px;
		padding-left: 8px;
		padding-right: 10px;
		width: 45px;
		font-weight: 700;
	}

	.painde_top {
		padding: 50px;
	}

	.bottom_onew {
		color: #e73262;
		border-color: #e73262;
		
	}

	.bottom_two {
		background: #e73262;
		color: #FFFFFF;

	}
	/* 表单头 */
	.table_header {
	    height: 36px;
	    line-height: 36px;
	    background: #f2f2f2;
	    display: flex;
	    justify-content: flex-start;
	    flex-wrap: wrap;
	}
	.table_content {
	    padding: 10px 0;
	    display: flex;
	    justify-content: flex-start;
	    flex-wrap: wrap;
	}
	 .table_date {
	    box-sizing: border-box;
	    width: 160px;
	    padding-left: 14px;
	    padding-right: 10px;
	}
	.table_merchantorder {
	    box-sizing: border-box;
	    word-break: break-all;
	    word-wrap: break-word;
	    width: 200px;
	    padding: 0 10px;
	    min-width: 160px;
	}
	.table_paymentorder {
	    box-sizing: border-box;
	    word-break: break-all;
	    word-wrap: break-word;
	    width: 200px;
	    min-width: 160px;
	    padding: 0 10px;
	    min-width: 160px;
	}
	.table_paymenttype {
	    box-sizing: border-box;
	    width: 98px;
	    padding: 0 10px;
	    min-width: 77px;
	}
	.table_status {
	    box-sizing: border-box;
	    width: 100px;
	    padding: 0 10px;
	    min-width: 66px;
	}
	.table_money {
	    box-sizing: border-box;
	    width: 100px;
	    padding: 0 10px;
	    min-width: 66px;
	}
	/* .table_content .table_money {
	    text-align: right;
	} */
	.table_operation {
	    padding: 0 10px;
	}
	.table_operation span {
	    margin-right: 10px;
	    padding-bottom: 2px;
	    border-bottom: 1px solid;
	}

	.icon_phigt {
		padding: 5px;
		margin-bottom: 100px;
	}

	.paind_bottm_end {
		padding-bottom: 10px;
	}

	.input_high i {
		font-size: 20px;
		padding-right: 10px;
	}

	.list_span_str {
		font-weight: 700;
		color: #e73262;
		margin-left: -80px;
		font-size: 15px;
	}

	.flex_display {
		display: flex;
	}

	.el-form-item {
		margin-bottom: 5px;
	}
	 .phone_box .progress_box {
	    position: relative;
	    line-height: 18px;
	    margin: 0 auto;
	    margin-top: 40px;
	    margin-bottom: 40px;
	    overflow: hidden;
	    color: #777777;
	 }
	  .progress_step {
	    display: flex;
	    justify-content: center;
	    align-items: center;
	    color: #e73262;
	  }
	  .progress_step > div {
	    box-sizing: border-box;
	    line-height: 18px;
	    display: flex;
	    justify-content: space-around;
	    align-items: center;
	  }
	  .progress_step > div > span {
	    margin: 0 6px;
	  }
	  .progress_step .active {
	    color: #e73262;
	  }
	  .progress_box .step_back {
	    height: 9px;
	    width: 620px;
	    background: #fdeaef;
	    position: absolute;
	    bottom: 0;
	    left: 50%;
	    margin-left: -310px;
	    z-index: -1;
	  }
	
	  .progress_box .icon_step {
	    display: inline-block;
	    height: 17px;
	    width: 17px;
	   }
	/* 01-建立帳號 */
	  .account_box{
	    box-sizing: border-box;
	    border: 2px solid #bbbbbb;
	    font-size: 13px;
	    color: #bbbbbb;
	    overflow: hidden;
	    width: 970px;
	    min-width: 970px;
	    margin: 0 auto;
	    padding: 36px 0;
	    margin-bottom: 38px;
	    display: flex;
	    justify-content: center;
	  }
	  .account {
	   overflow: hidden;
	   width: 660px;
	   line-height: 21px;
	   margin: 0 auto;
	  }
	  .account .el-form-item__label {
	    font-size: 13px;
	  }
	  .verification_success {
	    color: #6ac259;
	    font-size: 15px;
	    line-height: 21px;
	    margin-left: 10px;
	  }
	  .verification_error {
	    color: #e73262;
	    font-size: 15px;
	    line-height: 21px;
	    margin-left: 10px;
	  }
	  .account .phone_options {
	   width: 100px;
	  }
	  .account .account_input {
	   width: 260px;
	   margin: 0 14px;
	  }
	  .account .account_verification {
	   width: 280px;
	  }
	  .account .account_button {
	   width: 160px;
	  }
	  .account .account_alert {
	   width: 240px;
	  }
	 .account .account_next {
	   display: flex;
	   justify-content: center;
	   align-items: center;
	   margin: 70px 0 20px 0;
	  }
	 .account .account_next button {
	   width: 124px;
	   background: #e73262;
	   color: white;
	   border-radius: 6px;
	   text-align: center;
	   padding: 10px 0;
	   margin: 0 21px;
	   cursor:pointer;
	  }
	 .account .account_next .gray {
	   background: #999999;
	  }
	  .account .account_consent {
	    font-size: 13px;
	    text-align: center;
	    color: #777777;
	  }
	  .account .account_consent .consent_true {
	    margin-left: 8px;
	  }
	  .account .account_consent input {
	    width: 16px;
	    height: 16px;
	  }
	  .account .account_consent label {
	    padding-bottom: 2px;
	    border-bottom: 1px solid #999999;
	    margin: 0 6px;
	  }
	/* 02-完善資料 */
	  #business_img, #front_img, #reverse_img {
	    max-width: 400px;
	  }
	  .account_fun {
	    cursor: pointer;
	  }
	  .form_buttons {
	    font-size: 9px;
	    margin: 0;
	    color: #e73262;
	    margin-left: 10px;
	  }
	  .form_buttons_succ {
	    color: #6ac259;
	  }
	  .file_text {
	    color: #e73262;
	  }
	  .information_box {
	    box-sizing: border-box;
	    border: 2px solid #bbbbbb;
	    font-size: 17px;
	    color: #777777;
	    overflow: hidden;
	    width: 970px;
	    min-width: 970px;
	    margin: 0 auto;
	  }
	  .information_box .el-form-item__label {
	    font-size: 13px;
	  }
	  .information_box .title_box {
	    height: 55px;
	    line-height: 55px;
	    background: #f2f2f2;
	    text-align: center;
	  }
	  .information_box .title_box span {
	    font-weight: bold;
	  }
	  .information_box .title_box .active {
	    color: #e73262;
	  }
	  .information_box .information_form_title {
	    box-sizing: border-box;
	    width: 720px;
	    margin: 0 auto;
	    margin-top: 34px;
	    margin-bottom: 40px;
	    font-weight: bold;
	    color: #777777;
	    border-left: #e73262 12px solid;
	    padding-left: 10px;
	  }
	  .form_mail_box {
	    width: 800px;
	    margin: 0 auto;
	  }
	  .form_mail .form_mail_input {
	    width: 400px;
	  }
	  .information_form_next {
	    display: flex;
	    justify-content: center;
	    margin-bottom: 50px;
	  }
	  .information_form_next button {
	    width: 124px;
	    background: #e73262;
	    color: white;
	    border-radius: 6px;
	    text-align: center;
	    padding: 4px 0;
	    margin: 0 21px;
	    cursor:pointer;
	  }
	  .information_form_next .gray {
	    background: #999999;
	  }
	  /*  */
	  /* .identity_box  span{
	    margin: 0 10px;
	  } */
	  .identity_box .identity_box_select {
	    width: 70px;
	  }
	  .identity_box .select_year {
	    width: 100px;
	  }
	  .identity_box .span_first {
	    margin-right: 10px;
	  }
	  .identity_box .span_text {
	    margin: 0 10px;
	  }
	  .identity_box .span_last {
	    margin-left: 10px;
	  }
	  .bank_box {
	    width: 620px;
	    margin-left: 40px;
	  }
	  .bank_box .bank_name_box {
	    display: flex;
	    justify-content: flex-start;
	  }
	  .bank_box .bank_name_box li {
	    font-size: 15px;
	    box-sizing: border-box;
	    display: inline-block;
	    height: 43px;
	    line-height: 43px;
	    width: 310px;
	    text-align: center;
	    background: #f2f2f2;
	  }
	  .bank_box .bank_name_box .active {
	    border: #e73262 solid 2px;
	    background: white;
	    border-bottom: 0px;
	  }
	  .bank_box .bank_content {
	    box-sizing: border-box;
	    border: #e73262 solid 2px;
	    padding: 48px 30px;
	    padding-bottom: 30px;
	  }
	  .hotel_box {
	    padding-left: 30px;
	  }
	  .hotel_box .hotel_box_input {
	    width: 240px;
	  }
	  .hotel_box .hotel_box_text {
	    color: #e73262;
	    margin-left: 22px;
	  }
	  .type_box {
	    width: 440px;
	  }
	/* 03-送出申请 */
	  #business_img_to, #front_img_to, #reverse_img_to {
	    max-width: 400px;
	  }
	  .hotel_list_for > span{
	    float: left;
	    margin: 0 5px;
	  }
	  .icon_check_box {
	    border: 1px solid #777;
	  }
	/* 银行系列 */
	  .form_bank_box {
	    height: 18px;
	  }
	  .form_bank {
	    font-size: 13px;
	    color: #e73262;
	    text-align: center;
	    display: flex;
	    justify-content: center;
	    line-height: 18px;
	  }
	  .right_box {
	    height: 40px;
	    display: flex;
	    justify-content: flex-start;
	  }
	
	/* 发送审核 */
	  .button_box {
	    display: flex;
	    justify-content: center;
	    width: 600px;
	    margin: 0 auto;
	    margin-top: 40px;
	    margin-bottom: 50px;
	  }
	  .button_box .btns_sty {
	    margin: 0 30px;
	  }
		.color_list_e{
			color:#e73262 ;
			padding-left: 10px;
		}
	
	
</style>
